import Vue from 'vue';
import { MtCenterBlock } from '../MtCenterBlock';
import { MtHeaderInner } from '../MtHeaderInner';
import { MtIcon } from '../MtIcon';
import '../MtIcon/svg/wifi.svg';
import './MtHeader.css';
export default Vue.extend({
    name: 'MtHeader',
    props: {
        elevated: {
            type: Boolean,
        },
        logoUrl: {
            type: String,
        },
    },
    data: function () {
        return {
            internalLogoUrl: this.$props.logoUrl,
        };
    },
    watch: {
        logoUrl: function (value) {
            this.internalLogoUrl = value;
        },
    },
    methods: {
        onError: function () {
            this.internalLogoUrl = null;
        },
        generateFirst: function () {
            var _this = this;
            var DefaultContent = this.internalLogoUrl
                ? this.$createElement('img', {
                    attrs: {
                        src: this.internalLogoUrl,
                        alt: '',
                    },
                    on: {
                        error: function () { return _this.onError(); },
                    },
                })
                : this.$createElement(MtIcon, {
                    props: {
                        glyph: 'wifi',
                        width: '26',
                        height: '26',
                    },
                });
            var Logo = this.$createElement('div', {
                staticClass: 'mt-header__logo-wrapper',
                on: {
                    click: function () { return _this.$emit('click-logo'); },
                },
            }, [this.$slots.left || DefaultContent]);
            return this.$createElement('div', {
                staticClass: 'mt-header__block mt-header__block--first',
            }, [Logo]);
        },
        generateCenter: function () {
            return this.$slots.center
                ? this.$createElement('div', {
                    staticClass: 'mt-header__block mt-header__block--center',
                }, this.$slots.center)
                : null;
        },
        generateLast: function () {
            return this.$slots.right
                ? this.$createElement('div', {
                    staticClass: 'mt-header__block mt-header__block--last',
                }, this.$slots.right)
                : null;
        },
    },
    render: function (h) {
        return h('header', {
            staticClass: 'mt-header',
            class: { elevated: this.elevated },
        }, [
            h(MtCenterBlock, {}, [
                h(MtHeaderInner, {}, [
                    this.generateFirst(),
                    this.generateCenter(),
                    this.generateLast(),
                ]),
            ]),
        ]);
    },
});
//# sourceMappingURL=MtHeader.js.map